/**
 * @generated SignedSource<<615730ebe89b9f163bdfff097ab37358>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_MaybeRowWithDragAndDrop_project" | "row_nativeIssueTable_RowWithSiblingCreate_project">;
  readonly " $fragmentType": "row_nativeIssueTable_project";
};
export type row_nativeIssueTable_project$key = {
  readonly " $data"?: row_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowWithSiblingCreate_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "305a3dd7ddc9d2f8fd95d39ea0c44dcf";

export default node;
